export default __webpack_public_path__ + "static/team-working-azienda-perche-importante-b5f503c05842a545983903721a893a15.jpg";